import { Notify, Loading } from 'quasar'

export default {
  config: {},
  plugins: {
    Notify,
    Loading
  }
}